import React, { Component } from 'react';
import { connect } from 'react-redux';
import countries from 'country-calling-code';
import {
  Modal,
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
  Radio,
} from 'react-bootstrap';
import actions from '../../redux/actions';

var UsaStates = require('usa-states').UsaStates;

class PublicationEditAuthorPopup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      firstName: '',
      lastName: '',
      organization: '',
      originType: 'citizenship',
      citizenshipCountry: null,
      country: null,
      city: '',
      states: [],
      state: '',
      zip: '',
      address: '',
    };
  }

  componentWillMount() {
    const usStates = new UsaStates();
    const states = [{ abbreviation: 'Non-U.S.' }, ...usStates.states];
    this.setState({ states });
  }

  opened() {
    const { author } = this.props;
    this.setState({
      organization: author ? author.organization || '' : '',
      firstName: author ? author.firstName || '' : '',
      lastName: author ? author.lastName || '' : '',
      workforhire: author ? author.workforhire : -1,
      address: author ? author.address : '',
      state: author ? author.state : '',
      city: author ? author.city : '',
      zip: author ? author.zip : '',
      country: author ? author.country : '',
      citizenshipCountry: author ? author.citizenshipCountry : '',
    });

    if (author && author.citizenship) {
      this.setState({ citizenshipCountry: author.citizenship });
    } else if (author && author.domicile) {
      this.setState({ citizenshipCountry: author.domicile });
    }

    this.setState({
      originType: author && author.domicile ? 'domicile' : 'citizenship',
    });
  }

  close() {
    this.props.onClose();
  }

  save(e) {
    e.preventDefault();
    const {
      firstName,
      lastName,
      organization,
      originType,
      citizenshipCountry,
      country,
      city,
      state,
      zip,
      address,
    } = this.state;

    const data = {
      firstName,
      lastName,
      organization,
      citizenship:
        originType === 'citizenship' ? citizenshipCountry : '',
      domicile:
        originType === 'domicile' ? citizenshipCountry : '',
      citizenshipCountry,
      country,
      city,
      state,
      zip,
      address,
    };

    this.props.hideAlert();

    if (
      data.organization
        ? data.organization === ''
        : data.firstName === '' || !(data.citizenship || data.domicile)
    ) {
      this.props.alert('error', 'Please check the required fields.');
      return;
    }

    if (
      organization !== '' &&
      (firstName !== '' || lastName !== '')
    ) {
      this.props.alert('error', 'You must list an organization OR a person');
      return;
    }

    this.props.onSave(data);
    this.close();
  }

  handleChange(e, isAnonymous) {
    this.setState({
      anonymous: isAnonymous ? e.target.checked : !e.target.checked,
    });
  }

  handleFirstName(e) {
    this.setState({
      firstName: e.target.value,
    });
    this.clearRestField();
  }

  handleLastName(e) {
    this.setState({
      lastName: e.target.value,
    });
    this.clearRestField();
  }

  clearRestField() {
    this.setState({
      organization: '',
    });
  }

  handleOrganization(e) {
    this.setState({
      organization: e.target.value,
      firstName: '',
      lastName: '',
    });
  }

  handleOriginChange(originType) {
    this.setState({ originType });
  }

  handleCountry(country) {
    this.setState({ country });
  }

  handleCitizenshipCountry(citizenshipCountry) {
    this.setState({ citizenshipCountry });
  }

  handleWorkForHire(workforhire) {
    this.setState({ workforhire });
  }

  handleChange = (type, e) => {
    this.setState({ [type]: e.target.value });
  };

  render() {
    const {
      country,
      originType,
      citizenshipCountry,
      firstName,
      lastName,
      organization,
      city,
      state,
      zip,
      address,
      states,
    } = this.state;

    return (
      <Modal
        className="edit-author-modal publication"
        show={this.props.open}
        onEnter={() => this.opened()}
        onHide={() => this.close()}
      >
        <Form inline onSubmit={(e) => this.save(e)}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Author/Claimant</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <FormGroup>
              <ControlLabel>
                <span className="text-red">*</span>Organization:{' '}
              </ControlLabel>
              <FormControl
                type="text"
                value={organization}
                onChange={(e) => this.handleOrganization(e)}
              />
              <p className="small">
                If an organization owns this work (e.g. has commissioned
                it) list the organization here.
              </p>
            </FormGroup>
            <div className='text-center'>OR</div>
            <FormGroup>
              <ControlLabel>
                <span className="text-red">*</span>First Name:{' '}
              </ControlLabel>
              <FormControl
                type="text"
                value={firstName}
                onChange={(e) => this.handleFirstName(e)}
              />
            </FormGroup>
            <FormGroup>
              <ControlLabel>
                <span className="text-red">*</span>Last Name:{' '}
              </ControlLabel>
              <FormControl
                type="text"
                value={lastName}
                onChange={(e) => this.handleLastName(e)}
              />
            </FormGroup>
            <hr />
            <FormGroup>
              <ControlLabel>
                <span className="text-red">*</span>Citizenship:{' '}
              </ControlLabel>
              <FormGroup style={{
                display: 'grid',
                gridAutoFlow: 'column',
                alignItems: 'center',
              }}>
                <Radio
                  checked={originType === 'citizenship'}
                  onChange={() => this.handleOriginChange('citizenship')}
                >
                  Citizenship
                </Radio>
                <Radio
                  checked={originType === 'domicile'}
                  onChange={() => this.handleOriginChange('domicile')}
                >
                  Domicile
                </Radio>
                <FormControl
                  componentClass="select"
                  value={citizenshipCountry && citizenshipCountry !== '' ? citizenshipCountry : -1}
                  ref={(r) => (this.country = r)}
                  onChange={(e) => this.handleCitizenshipCountry(e.target.value)}
                >
                  <option disabled key={-1} value={-1}>
                    Select Country
                  </option>
                  {countries.map((country, i) => (
                    <option key={i} value={country.country}>
                      {country.country}
                    </option>
                  ))}
                </FormControl>
              </FormGroup>
            </FormGroup>
            <FormGroup>
              <ControlLabel>
                <span className="text-red">*</span>Address:{' '}
              </ControlLabel>
              <FormControl
                type="text"
                value={address}
                onChange={(e) => this.handleChange('address', e)}
              />
            </FormGroup>
            <FormGroup>
              <ControlLabel>
                <span className="text-red">*</span>City:{' '}
              </ControlLabel>
              <FormControl
                type="text"
                value={city}
                onChange={(e) => this.handleChange('city', e)}
              />
            </FormGroup>
            <FormGroup>
              <ControlLabel>
                <span className="text-red">*</span>State:{' '}
              </ControlLabel>
              <FormControl
                componentClass="select"
                value={state}
                onChange={(e) => this.handleChange('state', e)}
              >
                <option disabled key={-1} value={-1}>
                  Select State
                </option>
                {states.map((item, i) => (
                  <option key={i} value={item.abbreviation}>
                    {item.abbreviation}
                  </option>
                ))}
              </FormControl>
            </FormGroup>
            <FormGroup>
              <ControlLabel>
                <span className="text-red">*</span>Zip/Postal:{' '}
              </ControlLabel>
              <FormControl
                type="text"
                value={zip}
                onChange={(e) => this.handleChange('zip', e)}
              />
            </FormGroup>
            <FormGroup>
              <ControlLabel>
                <span className="text-red">*</span>Country:{' '}
              </ControlLabel>
              <FormControl
                componentClass="select"
                value={country && country !== '' ? country : -1}
                ref={(r) => (this.country = r)}
                onChange={(e) => this.handleCountry(e.target.value)}
              >
                <option disabled key={-1} value={-1}>
                  Select Country
                </option>
                {countries.map((country, i) => (
                  <option key={i} value={country.country}>
                    {country.country}
                  </option>
                ))}
              </FormControl>
            </FormGroup>
          </Modal.Body>

          <Modal.Footer>
            <div className="actions">
              <button type="submit">Save</button>
            </div>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  fields: state.coreg.fields,
  workTypes: state.global.workTypes,
  subWorkTypes: state.global.subWorkTypesCoreg,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PublicationEditAuthorPopup);



// WEBPACK FOOTER //
// src/components/Publication/PublicationEditAuthorPopup.jsx